
    <!-- Header Placeholder -->
    <app-header></app-header>
    
    <main class="container mx-auto px-4 pb-6 lg:px-6 lg:py-8">
        <!-- Hero Section -->
        <section class="mt-4 mb-8 lg:mb-12">
            <div class="bg-gradient-to-r from-wattpad-primary to-wattpad-secondary rounded-xl p-6 lg:p-8 text-white">
                <div class="flex flex-col lg:flex-row gap-6 items-center">
                    <div class="lg:w-1/3 flex justify-center">
                        <div class="bg-white/20 p-6 rounded-full w-48 h-48 flex items-center justify-center animate-float">
                            <i class="fas fa-book-reader text-6xl"></i>
                        </div>
                    </div>
                    <div class="lg:w-2/3 text-center lg:text-left">
                        <h1 class="text-2xl lg:text-4xl font-bold mb-2">About Us</h1>
                        <p class="text-xl lg:text-2xl mb-4 font-medium">Welcome to Funtel Stories</p>
                        
                        <p class="text-sm lg:text-base">
                            India's fast-growing digital storytelling platform designed for readers, listeners, and creators.
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- Our Story Section -->
        <section class="mb-8 lg:mb-12">
            <div class="bg-white dark:bg-gray-800 rounded-xl p-6 lg:p-8 shadow-sm">
                <div class="max-w-4xl mx-auto">
                    <h2 class="text-2xl lg:text-3xl font-bold mb-6 text-wattpad-primary text-center">Our Story</h2>
                    
                    <div class="space-y-6 text-lg">
                        <p>
                            At Funtel Stories, we believe that <span class="font-bold text-wattpad-primary">every story deserves a stage</span>. 
                            Whether it's a heart-touching romance, a thrilling horror tale, a mysterious fantasy world, 
                            or an inspiring life journey — stories have the power to move people, change perspectives, and create new worlds.
                        </p>
                        
                        <div class="bg-wattpad-accent/10 border border-wattpad-accent/20 rounded-xl p-6">
                            <div class="flex items-start">
                                <i class="fas fa-bullseye text-wattpad-accent text-xl mt-1 mr-4"></i>
                                <div>
                                    <h3 class="font-bold text-lg mb-2 text-wattpad-accent">Our Mission</h3>
                                    <p class="text-wattpad-dark dark:text-gray-300">
                                        To make these worlds accessible to everyone, anywhere, anytime.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Who We Are Section -->
        <section class="mb-8 lg:mb-12">
            <div class="bg-white dark:bg-gray-800 rounded-xl p-6 lg:p-8 shadow-sm">
                <h2 class="text-2xl lg:text-3xl font-bold mb-6 text-wattpad-primary text-center">Who We Are</h2>
                
                <div class="max-w-4xl mx-auto">
                    <p class="text-lg mb-8 text-center">
                        Funtel Stories is a new-age platform built by passionate storytellers, technologists, 
                        and creative minds who believe in the power of original stories.
                    </p>
                    
                    <div class="bg-wattpad-primary/10 rounded-xl p-6 mb-8">
                        <h3 class="text-xl font-bold mb-4 text-wattpad-primary text-center">We Bring Together</h3>
                        
                        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                            <div class="feature-card bg-white dark:bg-gray-700 rounded-lg p-4 text-center">
                                <div class="bg-wattpad-primary/20 p-3 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                                    <i class="fas fa-book text-wattpad-primary text-xl"></i>
                                </div>
                                <h4 class="font-bold">Webnovels</h4>
                            </div>
                            
                            <div class="feature-card bg-white dark:bg-gray-700 rounded-lg p-4 text-center">
                                <div class="bg-wattpad-primary/20 p-3 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                                    <i class="fas fa-file-alt text-wattpad-primary text-xl"></i>
                                </div>
                                <h4 class="font-bold">Short Stories</h4>
                            </div>
                            
                            <div class="feature-card bg-white dark:bg-gray-700 rounded-lg p-4 text-center">
                                <div class="bg-wattpad-primary/20 p-3 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                                    <i class="fas fa-headphones text-wattpad-primary text-xl"></i>
                                </div>
                                <h4 class="font-bold">Audio Stories</h4>
                            </div>
                            
                            <div class="feature-card bg-white dark:bg-gray-700 rounded-lg p-4 text-center">
                                <div class="bg-wattpad-primary/20 p-3 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                                    <i class="fas fa-stream text-wattpad-primary text-xl"></i>
                                </div>
                                <h4 class="font-bold">Serialized Fiction</h4>
                            </div>
                        </div>
                    </div>
                    
                    <div class="text-center">
                        <p class="text-lg font-medium">
                            From first-time writers to seasoned authors, we provide the space, tools, and audience for creators to shine.
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- What We Offer Section -->
        <section class="mb-8 lg:mb-12">
            <div class="bg-gradient-to-r from-wattpad-primary to-wattpad-secondary rounded-xl p-6 lg:p-8 text-white">
                <h2 class="text-2xl lg:text-3xl font-bold mb-6 text-center">What We Offer</h2>
                
                <div class="max-w-2xl mx-auto text-center">
                    <div class="bg-white/10 rounded-xl p-6 backdrop-blur-sm">
                        <div class="flex items-center justify-center mb-4">
                            <i class="fas fa-check-circle text-2xl text-green-300 mr-3"></i>
                            <span class="text-xl font-bold">Read & Listen Anytime, Anywhere</span>
                        </div>
                        
                        <p class="text-lg">
                            Access your favorite stories on any device, at any time. Whether you prefer reading or listening, 
                            Funtel Stories adapts to your lifestyle.
                        </p>
                    </div>
                </div>
            </div>
        </section>

      
    </main>
